import React from 'react';

import RenderedComponents from 'components/practice/charts/ClinicalNote/PreviewNote/Rendered/components/RenderedComponents';

const SingleClinicalNotePDF = ({ row }) => {
  return (
    <>
      <RenderedComponents
        {...row.componentProps}
        customClinicalNote={{ ...row?.customClinicalNote, patient: row?.patient }}
        className="!bg-transparent"
      />
    </>
  );
};

export default SingleClinicalNotePDF;
